import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ReceitaBrutaAnterior } from '../models/receitas-brutas-anteriores.model';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReceitasBrutasAnterioresService {
  private apiUrl = `${environment.advContabilApi}/api/ReceitaBrutaAnterior`;

  constructor(private http: HttpClient) { }

  getReceitasBrutasAnteriores(usuarioId: string): Observable<ReceitaBrutaAnterior[]> {
    const params = new HttpParams().set('usuarioId', usuarioId);

    return this.http.get<any[]>(`${this.apiUrl}/Listar`, { params }).pipe(
      map(data => data.map(item => ({
        id: item.id,
        periodoApuracao: item.pa,
        valorInterno: item.valorInterno,
        valorExterno: item.valorExterno,
        usuarioId: item.usuarioId || null
      })))
    );
  }

  adicionarReceitaBrutaAnterior(receitaBruta: Partial<ReceitaBrutaAnterior>): Observable<ReceitaBrutaAnterior> {
    return this.http.post<ReceitaBrutaAnterior>(`${this.apiUrl}/Inserir`, receitaBruta, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  obterReceitaBrutaAnterior(id: string): Observable<ReceitaBrutaAnterior> {
    return this.http.get<ReceitaBrutaAnterior>(`${this.apiUrl}/Obter/${id}`);
  }

  atualizar(id: string, dto: ReceitaBrutaAnterior): Observable<ReceitaBrutaAnterior> {
    return this.http.put<ReceitaBrutaAnterior>(`${this.apiUrl}/Atualizar/${id}`, dto);
  }

  deleteReceitaBrutaAnterior(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/Deletar/${id}`);
  }
}